module.exports = __webpack_public_path__ + "img/wireframe.d8564ca9.jpg";